import { Skeleton } from 'antd';
import moment, { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const ProjectDuration: FC<{
  startDate?: Moment | null;
  dueDate?: Moment | null;
  showDuration?: boolean;
}> = ({ startDate, dueDate, showDuration = false }) => {
  const formattedStartDate = startDate && startDate.format('DD MMM');
  const formattedDueDate = dueDate && dueDate.format('DD MMM');

  if (formattedStartDate && formattedDueDate && showDuration) {
    return (
      <FormattedMessage
        id="projects.create.preview.date.start_end.duration"
        values={{
          start: formattedStartDate,
          end: formattedDueDate,
          count: moment(dueDate || +new Date()).diff(startDate, 'day'),
        }}
      />
    );
  }

  if (formattedStartDate && formattedDueDate) {
    return (
      <FormattedMessage
        id="projects.create.preview.date.start_end"
        values={{ start: formattedStartDate, end: formattedDueDate }}
      />
    );
  }

  if (formattedStartDate) {
    return (
      <FormattedMessage
        id="projects.create.preview.date.start"
        values={{ date: formattedStartDate }}
      />
    );
  }

  if (formattedDueDate) {
    return (
      <FormattedMessage
        id="projects.create.preview.date.end"
        values={{ date: formattedDueDate }}
      />
    );
  }

  return <Skeleton.Input style={{ width: 100, height: 12 }} size="small" />;
};
